import {MESSAGES} from "./strings";
import React from 'react';
import { toastr } from 'react-redux-toastr';

const UTILS = {
    renderAttempt: (n) => {
        return n > 1 ? "attempts" : "attempt";

    },
    changeDateFormat: (input) => {
        var date = '';
        if(input.getDate() < 10) {
            date = `0${input.getDate()}`;
        } else {
            date = input.getDate();
        }
        return `${input.getFullYear()}-0${input.getMonth() + 1}-${date}`;
    },
    renderLoadingData: () => {
        return (
            <div className="loading">Loading data...</div>
        )
    },
    handleCopyBtn: (url, message = '' ) => {
        let textArea = document.createElement('textarea');
        textArea.style.width = '2em';
        textArea.style.height = '2em';

        // We don't need padding, reducing the size if it does flash render.
        textArea.style.padding = 0;

        // Clean up any borders.
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';

        // Avoid flash of white box if rendered for any reason.
        textArea.style.background = 'transparent';
        textArea.value = url;

        document.body.appendChild(textArea);
        textArea.select();

        try {
            const isSuccess = document.execCommand("copy");
            if (isSuccess) {
                toastr.success( '' === message ? MESSAGES.COPY_LINK_TO_CLIPBOARD : message );
            }

        } catch (err) {
            console.log("Opps, unable to copy!")
        }

        document.body.removeChild(textArea);
    }
}

export default UTILS
